import { createClient } from '@sanity/client'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

const client = createClient({
  projectId: import.meta.env.VITE_SANITY_PROJECT_ID || '',
  dataset: import.meta.env.VITE_SANITY_DATASET || '',
  apiVersion: '2025-06-09',
  useCdn: true,
})

interface GameIconData {
  gameIcon?: {
    icon?: {
      asset?: {
        url?: string
      }
    }
  }
}

const GAME_ICON_QUERY = `*[_type == "game" && dynamoId == $gameId && i18n_lang == "en-GB"] {
  gameIcon->{
    icon{
      asset->{
        url
      }
    }
  }
} | order(!(_id in path("drafts.**"))) [0]`

const useGameIcon = (gameId?: string) => {
  const queryFn = useMemo(
    () => async (): Promise<string | null> => {
      if (!gameId) return null

      try {
        const result = await client.fetch<GameIconData>(GAME_ICON_QUERY, {
          gameId,
        })

        return result?.gameIcon?.icon?.asset?.url || null
      } catch (error) {
        console.warn('Failed to fetch game icon from Sanity:', error)
        return null
      }
    },
    [gameId]
  )

  return useQuery({
    queryKey: ['gameIcon', gameId],
    queryFn,
    enabled: Boolean(gameId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  })
}

export default useGameIcon
